export default __webpack_public_path__ + "static/media/pause.b52642a6.svg";